import axios from 'axios'
import { getToken } from '../user/tokens'
import { getSeriesIdFromPayload, addWatchHistoryToPayload, formatHistory, addEpisodeNumbersToPayload, fetchCurrentLanguage } from './helpers';
import Cookies from 'js-cookie';
import userLanguageSelector from '~/tools/localization/userLanguageSelector'
import jwtDecode from 'jwt-decode'

export const setLoadingPage = fetching => {
  return {
    type: 'FETCHING_PAGE',
    payload: fetching
  };
};

export const fetchPage = (route, langCode, ip, userId) => async (dispatch) => {
  if (userId == null) {
    userId = Cookies.get('vl-user');
  }
  dispatch(setLoadingPage(true));
  var languageCode = ""
  
  if (langCode === "" && window.settings.languages) {
    languageCode = await fetchCurrentLanguage(ip);
    languageCode = window.settings.languages.default.code
    Cookies.set('userLanguageSelection', languageCode)
  } else if(!langCode && window.settings.languages) {
    languageCode = userLanguageSelector()
  } else {
    languageCode = langCode
  }
  const token = await getToken()
  var decodedToken = jwtDecode(token);
  var tokenCountryCode = decodedToken.countryCode

  var
    s = window.settings,
    content,
    layout
    console.log(`${new Date()} Fetching page data\n`)
    let apiUrl = ""
		if(s.apiBaseUrl === "https://prod-api.viewlift.com") {
			apiUrl = "https://prod-api-cached-2.viewlift.com"
		} else {
			apiUrl = s.apiBaseUrlCached || s.apiBaseUrl
    }
    var contentUrl = apiUrl + s.pageEndpoint
  var contentApiHeaders = {
    Authorization: token,
    'x-api-key': s.baseAPIKey,
  }
  var defaultModuleLimit = 4
  if(window && window.settings && window.settings.features && window.settings.features.defaultModuleLimit) {
    defaultModuleLimit = window.settings.features.defaultModuleLimit
  }
  if (ip)
    contentApiHeaders['X-Forwarded-For'] = ip
  return axios
    .get(contentUrl, {
      params: {
        path: route,
        site: s.internalName,
        includeContent: true,
        moduleOffset: 0,
        moduleLimit: defaultModuleLimit,
        countryCode: tokenCountryCode,
        languageCode : languageCode ? languageCode : "default"
      },
      headers: contentApiHeaders
    })
    .then(r => {
      console.log(`${new Date()} Fetched page data\n`)
      content = r.data
      addEpisodeNumbersToPayload(content);

      var layoutUrl = `${s.layoutUrlBase}${s.siteId}/web/${content.id}.json`

      var layoutApiHeaders = ip ? { 'X-Forwarded-For': ip } : {}
      return axios.get(layoutUrl, { headers: layoutApiHeaders }).then(s => layout = s.data)
    })
    // Get watch history for videos if we are on a showpage. This is a hack as the information would ideally be already in the pages API
    // UPDATED: Do it on client side too now
    .then(_ => {
      const payload = {
        title: content.title,
        categoryMap: content.categoryMap,
        metadataMap: content.metadataMap,
        id: content.id,
        modulesCount: content.moduleCount,
        modules: content.modules,
        layouts: layout.moduleList,
        styles: layout.pageStyle,
        route: route,
        ip: ip,
        lang: languageCode
      }
      dispatch({ type: 'FETCH_PAGE', payload: payload })
      dispatch(setLoadingPage(false));
    })
    .catch(e => {
      dispatch({ type: 'FETCH_PAGE_REJECTED', payload: e.response })
      dispatch(setLoadingPage(false));
    })


}